export default "__VITE_ASSET__0c000186__"